/*
 * @Author:
 * @LastEditTime: 2022-01-10 14:41:15
 * @Description:公共下载方法
 */
const downLoadExcel = (fileName = '下载文件', data) => {
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `${fileName}`
  link.click()
  window.URL.revokeObjectURL(link.href)
}

const downloadBlob = (data) => {
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = '下载文件'
  link.click()
  window.URL.revokeObjectURL(link.href)
}

const downloadFile = (fileName, content) => {
  const blob = new Blob([content], { type: 'application/vnd.ms-excel' })
  const url = window.URL.createObjectURL(blob)
  window.open(url, '_blank')
}

const download = (fileName = '下载文件', data, type) => {
  const blob = new Blob([data], {
    type,
  })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `${fileName}`
  link.click()
  window.URL.revokeObjectURL(link.href)
}

export { downLoadExcel, downloadBlob, downloadFile, download }
